/*
 * @Author: liuc
 * @Date: 2020-04-08 13:43:52
 * @Description:
 */
/**
 * @Description: code码
 */
const RETURN_CODE = [{
    code: 200,
    msg: '执行成功'
}];

// 业务状态码
const BUSINESS_CODE = [];

const CODE_SUCCESS = 200;

const CODE_OCCUPIED = [600, 601]; // 账号被占用，600表示token失效

export {
    RETURN_CODE,
    CODE_SUCCESS,
    BUSINESS_CODE, // 业务状态码
    CODE_OCCUPIED
};



// WEBPACK FOOTER //
// ./src/axios/code.js